(() => {
'use strict';
const KP = window.KP || (window.KP = {});
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const R = String(KP.root || '/').replace(/\/?$/, '/');
const T = (k, v = {}) => { let s = (KP.t && KP.t[k]) || ''; Object.keys(v).forEach(x => { s = s.split('[' + x + ']').join(v[x]); }); return s; };
const loc = KP.locale || 'nl';
let nf, nfShop;
try { nf = new Intl.NumberFormat(loc, { style: 'currency', currency: KP.currency || 'EUR' }); } catch (e) { nf = new Intl.NumberFormat('nl', { style: 'currency', currency: 'EUR' }); }
try { nfShop = new Intl.NumberFormat(loc, { style: 'currency', currency: KP.shopCurrency || 'EUR' }); } catch (e) { nfShop = nf; }
const fmt = c => nf.format((c || 0) / 100);
const fmt0 = c => nf.format(Math.round((c || 0) / 100)).replace(/[.,]00(?=\D*$)/, '');
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const sized = (u, w) => { if (!u) return ''; if (typeof u === 'object') u = u.src || u.url || ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
const store = {
  get(k, d) { try { const v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
};
const fine = matchMedia('(pointer:fine)').matches;
const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
const tiers = (KP.tiers || []).filter(Boolean).map(t => Object.assign({}, t, { cents: Math.round(t.amount * 100 * rate) })).sort((a, b) => a.cents - b.cents);
const bogoTypes = (KP.bogoTypes || []).map(s => String(s).trim().toLowerCase()).filter(Boolean);
const isBogo = type => bogoTypes.includes(String(type || '').toLowerCase());
const isGift = i => i.properties && i.properties._kp_gift;

async function api(path, body) {
  const opt = { headers: { Accept: 'application/json' } };
  if (body) {
    opt.method = 'POST';
    if (body instanceof FormData) opt.body = body;
    else { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
  }
  const r = await fetch(R + path, opt);
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw j;
  return j;
}

/* ---------- feedback fx ---------- */
let tt;
function toast(msg) { const el = $('#kp-toast'); if (!el || !msg) return; el.textContent = msg; el.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => el.classList.remove('is-on'), 2600); }
function burst(x, y, n) {
  if (calm || !document.body.animate) return;
  n = n || 26;
  const cols = ['#ff2d95', '#e00012', '#fff4f9', '#ff7ab9', '#ffb800'];
  for (let i = 0; i < n; i++) {
    const el = document.createElement('span');
    const s = 6 + Math.random() * 10, heart = Math.random() < .35, c = cols[i % cols.length];
    el.textContent = heart ? '\u2665' : '';
    el.style.cssText = 'position:fixed;left:' + x + 'px;top:' + y + 'px;width:' + s + 'px;height:' + s + 'px;background:' + (heart ? 'transparent' : c) + ';color:' + c + ';font-size:' + (s * 1.8) + 'px;line-height:1;border-radius:' + (Math.random() < .5 ? '50%' : '2px') + ';pointer-events:none;z-index:600';
    document.body.appendChild(el);
    const a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 160;
    el.animate([
      { transform: 'translate(-50%,-50%) scale(1) rotate(0)', opacity: 1 },
      { transform: 'translate(' + Math.cos(a) * d + 'px,' + (Math.sin(a) * d + 80) + 'px) scale(.4) rotate(' + Math.random() * 720 + 'deg)', opacity: 0 }
    ], { duration: 900 + Math.random() * 600, easing: 'cubic-bezier(.2,.8,.3,1)' }).onfinish = () => el.remove();
  }
}
function fly(img) {
  const tgt = $$('[data-cart-count]').find(e => e.offsetParent);
  if (calm || !img || !tgt || !img.animate) return;
  const a = img.getBoundingClientRect(), b = tgt.getBoundingClientRect();
  if (!a.width) return;
  const c = img.cloneNode();
  c.removeAttribute('srcset'); c.removeAttribute('sizes');
  c.style.cssText = 'position:fixed;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;z-index:599;border-radius:24px;background:#fff;object-fit:contain;pointer-events:none;box-shadow:0 20px 60px rgba(255,45,149,.6);margin:0;opacity:1';
  document.body.appendChild(c);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
  c.animate([
    { transform: 'translate(0,0) scale(1) rotate(0)' },
    { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 120) + 'px) scale(.5) rotate(-15deg)', offset: .5 },
    { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08) rotate(20deg)', opacity: .4 }
  ], { duration: 800, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => c.remove();
}
document.addEventListener('pointerdown', e => {
  const b = e.target.closest('.kp-btn,.kp-optbtn,.kp-tab,.kp-quick__btn,.kp-mini,.kp-tierbtn');
  if (!b || calm) return;
  const r = b.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2.2;
  const sp = document.createElement('span');
  sp.className = 'kp-ripple';
  sp.style.cssText = 'left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px;width:' + s + 'px;height:' + s + 'px';
  if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
  b.style.overflow = 'hidden';
  b.appendChild(sp);
  setTimeout(() => sp.remove(), 650);
});

/* ---------- layers ---------- */
function syncLock() { document.documentElement.classList.toggle('kp-lock', !!$('.kp-modal.is-open,.kp-drawer.is-open,.kp-menu.is-open,#kp-age:not(.is-out)') && !document.documentElement.classList.contains('kp-aged-only')); }
let lastFocus = null;
function openModal(el) { if (!el) return; lastFocus = document.activeElement; el.hidden = false; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); requestAnimationFrame(() => requestAnimationFrame(() => { el.classList.add('is-open'); const f = el.querySelector('input:not([type=hidden]),button:not([data-close-modal]),a[href]') || el.querySelector('.kp-modal__box'); if (f) { if (!f.hasAttribute('tabindex') && f.classList.contains('kp-modal__box')) f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); } })); syncLock(); }
function closeModal(el) { if (!el) return; el.classList.remove('is-open'); setTimeout(() => { el.hidden = true; syncLock(); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }, 320); }
document.addEventListener('keydown', e => { if (e.key !== 'Tab') return; const m = $('.kp-modal.is-open') || $('.kp-drawer.is-open .kp-drawer__panel'); if (!m) return; const f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', m).filter(x => x.offsetParent); if (!f.length) return; const a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } });
document.addEventListener('click', e => { const c = e.target.closest('[data-close-modal]'); if (c) { e.preventDefault(); closeModal(c.closest('.kp-modal')); } });
document.addEventListener('keydown', e => { if (e.key === 'Escape') { $$('.kp-modal.is-open').forEach(closeModal); closeCart(); const m = $('#kp-menu'); m && m.classList.remove('is-open'); syncLock(); } });

/* ---------- age gate ---------- */
const age = $('#kp-age');
if (age) {
  if (store.get('kp_age', false)) age.remove();
  else {
    syncLock();
    const yes = $('[data-age-yes]', age);
    yes && yes.addEventListener('click', () => {
      store.set('kp_age', true);
      age.classList.add('is-out');
      syncLock();
      setTimeout(() => age.remove(), 500);
      queueWheel();
    });
  }
}

/* ---------- header, progress, skew ---------- */
const header = $('#kp-header'), prog = $('#kp-progress');
let lastY = scrollY, skT;
function onScroll() {
  const y = scrollY;
  header && header.classList.toggle('is-scrolled', y > 40);
  if (prog) { const H = document.documentElement.scrollHeight - innerHeight; prog.style.transform = 'scaleX(' + (H > 0 ? y / H : 0) + ')'; }
  if (!calm) {
    const v = Math.max(-6, Math.min(6, (y - lastY) * .12));
    $$('[data-skew]').forEach(el => { el.style.transform = 'skewY(' + (v * .3) + 'deg)'; });
    clearTimeout(skT);
    skT = setTimeout(() => $$('[data-skew]').forEach(el => { el.style.transform = ''; }), 120);
  }
  lastY = y;
}
addEventListener('scroll', onScroll, { passive: true });
onScroll();
document.addEventListener('click', e => {
  const t = e.target.closest('[data-menu-toggle]');
  if (t) { const m = $('#kp-menu'); if (m) { m.classList.toggle('is-open'); syncLock(); } }
});

/* ---------- reveal + split ---------- */
const io = ('IntersectionObserver' in window && !calm) ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -40px 0px' }) : null;
function initReveal(root) {
  const els = $$('.kp-reveal:not(.is-in)', root || document);
  if (!io) { els.forEach(e => e.classList.add('is-in')); return; }
  els.forEach((el, i) => { el.style.transitionDelay = ((i % 4) * 70) + 'ms'; io.observe(el); });
}
initReveal();
setTimeout(() => $$('.kp-reveal').forEach(e => e.classList.add('is-in')), 6000);
$$('[data-split]').forEach((el, k) => {
  if (calm) return;
  const txt = el.textContent.trim();
  el.setAttribute('aria-label', txt);
  el.textContent = '';
  Array.from(txt).forEach((ch, i) => {
    const s = document.createElement('span');
    s.className = 'kp-ch';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = ch === ' ' ? '\u00a0' : ch;
    s.style.animationDelay = (k * .35 + i * .05) + 's';
    el.appendChild(s);
  });
});

/* ---------- pointer fx ---------- */
if (fine && !calm) {
  const glow = $('#kp-glow');
  let lastTilt = null;
  addEventListener('mousemove', e => {
    if (glow) glow.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
    const hero = $('[data-hero]');
    if (hero) {
      const r = hero.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        const dx = (e.clientX - r.width / 2) / r.width, dy = (e.clientY - r.top - r.height / 2) / r.height;
        const logo = $('[data-hero-logo]', hero);
        if (logo) logo.style.transform = 'perspective(900px) rotateY(' + dx * 14 + 'deg) rotateX(' + (-dy * 10) + 'deg) translate(' + dx * 20 + 'px,' + dy * 14 + 'px)';
        $$('[data-depth]', hero).forEach(el => { const d = +el.dataset.depth; el.style.transform = 'translate(' + dx * d + 'px,' + dy * d + 'px)'; });
      }
    }
    $$('[data-magnet]').forEach(el => {
      const b = el.getBoundingClientRect(), mx = e.clientX - (b.left + b.width / 2), my = e.clientY - (b.top + b.height / 2);
      el.style.transform = Math.hypot(mx, my) < 110 ? 'translate(' + mx * .22 + 'px,' + my * .28 + 'px)' : '';
    });
    const t = e.target.closest && e.target.closest('[data-tilt]');
    if (lastTilt && lastTilt !== t) lastTilt.style.transform = '';
    lastTilt = t;
    if (t) {
      const b = t.getBoundingClientRect(), x = (e.clientX - b.left) / b.width - .5, y = (e.clientY - b.top) / b.height - .5;
      t.style.transform = 'perspective(800px) rotateY(' + x * 10 + 'deg) rotateX(' + (-y * 10) + 'deg) scale(1.02)';
    }
  }, { passive: true });
}

/* ---------- tabs + countdown + sort ---------- */
document.addEventListener('click', e => {
  const b = e.target.closest('[data-tab]');
  if (!b) return;
  const box = b.closest('[data-tabs]');
  $$('[data-tab]', box).forEach(x => x.classList.toggle('is-on', x === b));
  $$('[data-panel]', box).forEach(p => { p.hidden = p.dataset.panel !== b.dataset.tab; if (!p.hidden) { $$('.kp-reveal', p).forEach(r => r.classList.remove('is-in')); initReveal(p); } });
});
$$('[data-countdown]').forEach(el => {
  const end = new Date(String(el.dataset.countdown).replace(' ', 'T')).getTime();
  const box = el.closest('[data-promo]');
  if (!end) { el.hidden = true; return; }
  const u = $$('[data-cd]', el);
  const tick = () => {
    const l = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (l <= 0 && box && box.dataset.hideExpired === 'true') box.hidden = true;
    const vals = [Math.floor(l / 86400), Math.floor(l / 3600) % 24, Math.floor(l / 60) % 60, l % 60];
    u.forEach((x, i) => { x.textContent = String(vals[i]).padStart(2, '0'); });
  };
  tick(); setInterval(tick, 1000);
});
$$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }));
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-load-more]');
  if (!b) return;
  e.preventDefault();
  b.classList.add('is-loading');
  try {
    const html = await (await fetch(b.dataset.loadMore)).text();
    const d = new DOMParser().parseFromString(html, 'text/html');
    const grid = $('#kp-grid');
    $$('#kp-grid > *', d).forEach(n => grid.appendChild(document.importNode(n, true)));
    const nb = d.querySelector('[data-load-more]');
    if (nb) b.dataset.loadMore = nb.dataset.loadMore; else b.remove();
    const cnt = d.querySelector('[data-shown]'), cur = $('[data-shown]');
    if (cnt && cur) cur.textContent = cnt.textContent;
    initReveal(grid); wishRender();
  } catch (err) {}
  b.classList.remove('is-loading');
});

/* ---------- cart ---------- */
const drawer = $('#kp-drawer');
let CART = null;
const recCache = {};
function openCart() { if (!drawer) { location.href = R + 'cart'; return; } drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); syncLock(); const p = $('#kp-pill'); if (p) p.hidden = true; }
function closeCart() { if (!drawer || !drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); syncLock(); CART && render(CART); }

document.addEventListener('click', e => {
  const o = e.target.closest('[data-open-cart]');
  if (o) { e.preventDefault(); openCart(); refresh(); return; }
  if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); return; }
  const q = e.target.closest('[data-line]');
  if (q) { e.preventDefault(); changeLine(q.dataset.line, +q.dataset.q, q); return; }
  const ad = e.target.closest('[data-add-variant]');
  if (ad) { e.preventDefault(); addItems([{ id: +ad.dataset.addVariant, quantity: +(ad.dataset.qty || 1) }], ad); return; }
  const ck = e.target.closest('[data-checkout]');
  if (ck) { e.preventDefault(); goCheckout(); }
});
async function addItems(items, srcEl) {
  try { srcEl && srcEl.classList.add('is-loading'); await api('cart/add.js', { items: items }); afterAdd(srcEl); }
  catch (err) { toast(err.description || err.message); }
  finally { srcEl && srcEl.classList.remove('is-loading'); }
}
function afterAdd(srcEl) {
  const box = srcEl && srcEl.closest('.kp-card,.kp-pdp,.kp-bundle,.kp-upsell,.kp-qres__i,.kp-offer,.kp-fbt');
  let img = box && box.querySelector('img');
  if (box && box.classList.contains('kp-pdp')) img = $('#kp-main-img') || img;
  if (img) fly(img);
  const r = (srcEl || document.body).getBoundingClientRect();
  burst(r.left + r.width / 2, r.top + r.height / 2);
  toast(T('added'));
  refresh(true);
}
document.addEventListener('submit', async e => {
  const f = e.target.closest('form[data-kp-add]');
  if (!f) return;
  e.preventDefault();
  const btn = f.querySelector('[type=submit]');
  btn && btn.classList.add('is-loading');
  try { await api('cart/add.js', new FormData(f)); afterAdd(btn || f); }
  catch (err) { toast(err.description || err.message); }
  finally { btn && btn.classList.remove('is-loading'); }
});
async function changeLine(key, qty, el) {
  el && el.classList.add('is-loading');
  try { await api('cart/change.js', { id: key, quantity: Math.max(0, qty) }); await refresh(); }
  catch (err) { toast(err.description || err.message); }
  el && el.classList.remove('is-loading');
}
function subNoGift(c) { return c.items.reduce((a, i) => a + (isGift(i) ? 0 : i.final_line_price), 0); }
async function syncGifts(cart) {
  if (!tiers.some(t => t.variant)) return cart;
  const sub = subNoGift(cart);
  let changed = false;
  for (const t of tiers) {
    if (!t.variant) continue;
    const line = cart.items.find(i => isGift(i) && String(i.properties._kp_gift) === String(t.idx));
    const reach = sub >= t.cents;
    try {
      if (reach && !line) { await api('cart/add.js', { items: [{ id: t.variant, quantity: 1, properties: { _kp_gift: String(t.idx) } }] }); changed = true; }
      else if (!reach && line) { await api('cart/change.js', { id: line.key, quantity: 0 }); changed = true; }
      else if (line && line.quantity > 1) { await api('cart/change.js', { id: line.key, quantity: 1 }); changed = true; }
    } catch (e) {}
  }
  return changed ? api('cart.js') : cart;
}
let refreshing = null;
async function refresh(open) {
  if (refreshing) await refreshing.catch(() => {});
  refreshing = (async () => {
    let c = await api('cart.js');
    c = await syncGifts(c);
    CART = c;
    render(c);
    if (open && KP.autoOpen !== false) openCart();
  })();
  return refreshing.catch(() => {});
}
function ladderHTML(sub, big) {
  if (!tiers.length) return '';
  const max = tiers[tiers.length - 1].cents;
  const next = tiers.find(t => sub < t.cents);
  const pct = Math.min(100, sub / max * 100);
  const head = next ? T('tier_left', { amount: fmt(next.cents - sub), reward: esc(next.label) }) : T('all_unlocked');
  return '<div class="kp-ladder' + (big ? ' kp-ladder--big' : '') + '"><p class="kp-ladder__t">' + head + '</p><div class="kp-ladder__bar"><i style="width:' + pct + '%"></i>' +
    tiers.map(t => { const on = sub >= t.cents; return '<span class="kp-ladder__dot' + (on ? ' is-on' : '') + '" style="left:' + (t.cents / max * 100) + '%"><b>' + (on ? '\u2713' : '') + '</b><em>' + fmt0(t.cents) + '<br>' + esc(t.short || t.label) + '</em></span>'; }).join('') +
    '</div></div>';
}
function render(c) {
  $$('[data-cart-count]').forEach(el => { if (el.textContent != c.item_count) { el.textContent = c.item_count; el.classList.remove('kp-pop'); void el.offsetWidth; el.classList.add('kp-pop'); } });
  const sub = subNoGift(c);
  $$('[data-ladder]').forEach(el => { el.innerHTML = ladderHTML(sub, el.dataset.ladder === 'big'); });
  $$('[data-tier-card]').forEach(el => {
    const t = tiers.find(x => String(x.idx) === el.dataset.tierCard); if (!t) return;
    const on = sub >= t.cents; el.classList.toggle('is-on', on);
    const st = $('.kp-lcard__st', el); if (st) st.textContent = on ? el.dataset.on : '+' + fmt(t.cents - sub);
  });
  renderPill(c, sub);
  if (!drawer) return;
  const body = $('[data-drawer-body]', drawer), foot = $('[data-drawer-foot]', drawer);
  if (!c.item_count) {
    body.innerHTML = '<div class="kp-empty"><b>' + esc(T('empty')) + '</b><a href="' + R + 'collections/all" class="kp-btn">' + esc(T('complete')) + '</a></div>';
    foot.hidden = true;
    return;
  }
  foot.hidden = false;
  let h = '';
  const code = store.get('kp_code', null);
  if (code) h += '<div class="kp-note">' + esc(T('code_active', { code: code })) + '</div>';
  const cnt = {};
  c.items.forEach(i => { if (!isGift(i) && isBogo(i.product_type)) { const k = i.product_type.toLowerCase(); cnt[k] = cnt[k] || { q: 0, line: i }; cnt[k].q += i.quantity; } });
  Object.keys(cnt).forEach(k => { if (cnt[k].q % 2) { const l = cnt[k].line; h += '<div class="kp-nudge kp-shine"><b>' + esc(T('bogo_nudge')) + '</b><button type="button" data-line="' + esc(l.key) + '" data-q="' + (l.quantity + 1) + '">+1 ' + esc(l.product_title) + '</button></div>'; } });
  h += c.items.map(it => {
    const gift = isGift(it);
    return '<div class="kp-line' + (gift ? ' kp-line--gift' : '') + '"><a href="' + esc(it.url) + '"><img src="' + esc(sized(it.image, 160)) + '" alt="" loading="lazy"></a><div class="kp-line__m"><a href="' + esc(it.url) + '" class="kp-line__t">' + esc(it.product_title) + '</a>' +
      (it.variant_title ? '<span class="kp-line__v">' + esc(it.variant_title) + '</span>' : '') +
      (gift ? '<span class="kp-badge kp-badge--pink" style="align-self:flex-start">' + esc(T('free')) + '</span>' : '<div class="kp-qty kp-qty--s"><button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">\u2212</button><span>' + it.quantity + '</span><button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div>') +
      '</div><div class="kp-line__p">' + (it.final_line_price < it.original_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + '<b>' + (it.final_line_price === 0 ? esc(T('free')) : fmt(it.final_line_price)) + '</b></div></div>';
  }).join('');
  h += '<div data-upsell></div>';
  body.innerHTML = h;
  const saved = c.original_total_price - c.total_price;
  let f = '<div class="kp-sum"><span>' + esc(T('subtotal')) + '</span><b>' + fmt(c.original_total_price) + '</b></div>';
  if (saved > 0) f += '<div class="kp-sum kp-sum--disc"><span>' + esc(T('discount')) + '</span><b>\u2212' + fmt(saved) + '</b></div>';
  f += '<div class="kp-sum kp-sum--total"><span>' + esc(T('total')) + '</span><b>' + fmt(c.total_price) + '</b></div>';
  if (saved > 0) f += '<div class="kp-saved">' + esc(T('you_save', { amount: fmt(saved) })) + '</div>';
  if (KP.showPoints) f += '<div class="kp-points">\u2605 ' + esc(T('points', { points: Math.floor(c.total_price / 100 / rate * (KP.pointsPerEuro || 1)) })) + '</div>';
  f += '<button type="button" class="kp-btn kp-btn--big kp-shine" data-checkout>' + esc(T('checkout')) + '</button>';
  f += '<p class="kp-paynote">' + esc(T('payments')) + '</p>';
  foot.innerHTML = f;
  loadUpsell(c);
  document.dispatchEvent(new CustomEvent('kp:cart', { detail: c }));
}
async function loadUpsell(c) {
  const box = drawer && $('[data-upsell]', drawer);
  const base = c.items.find(i => !isGift(i));
  if (!box || !base) return;
  const pid = base.product_id;
  try {
    let list = recCache[pid];
    if (!list) {
      const j = await api('recommendations/products.json?product_id=' + pid + '&limit=8&intent=complementary').catch(() => ({ products: [] }));
      list = j.products || [];
      if (list.length < 3) { const j2 = await api('recommendations/products.json?product_id=' + pid + '&limit=8').catch(() => ({ products: [] })); list = list.concat(j2.products || []); }
      recCache[pid] = list;
    }
    const inCart = new Set(c.items.map(i => i.product_id));
    const pick = list.filter((p, i, a) => p.available && !inCart.has(p.id) && a.findIndex(x => x.id === p.id) === i).slice(0, 3);
    if (!pick.length) return;
    box.innerHTML = '<h4 class="kp-upsell__h">' + esc(T('complete')) + '</h4>' + pick.map(p => {
      const v = p.variants.find(x => x.available) || p.variants[0];
      return '<div class="kp-upsell"><img src="' + esc(sized(p.featured_image, 160)) + '" alt="" loading="lazy"><div><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span>' + fmt(v.price) + (isBogo(p.type) ? ' \u00b7 ' + esc(T('bogo')) : '') + '</span></div><button type="button" class="kp-mini" data-add-variant="' + v.id + '">+ ' + esc(T('add')) + '</button></div>';
    }).join('');
  } catch (e) {}
}
function renderPill(c, sub) {
  const pill = $('#kp-pill');
  if (!pill) return;
  const show = c.item_count > 0 && tiers.length && !(drawer && drawer.classList.contains('is-open'));
  pill.hidden = !show;
  if (!show) return;
  const next = tiers.find(t => sub < t.cents);
  const pct = next ? Math.min(100, sub / next.cents * 100) : 100;
  pill.style.setProperty('--p', (pct * 3.6) + 'deg');
  $('[data-pill-pct]', pill).textContent = next ? Math.round(pct) + '%' : '\u2713';
  $('[data-pill-t]', pill).textContent = next ? '+' + fmt(next.cents - sub) : T('all_unlocked');
  $('[data-pill-s]', pill).textContent = next ? next.label : '';
}

/* ---------- checkout + one-time offer ---------- */
function checkoutUrl(code) {
  code = code || store.get('kp_code', null);
  return code ? R + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R + 'checkout') : R + 'checkout';
}
const offer = $('#kp-offer');
let offerT;
function goCheckout() {
  const vid = offer && +offer.dataset.variant;
  let seen = false; try { seen = sessionStorage.getItem('kp_offer'); } catch (e) {}
  if (offer && vid && !seen && CART && !CART.items.some(i => i.variant_id === vid)) {
    try { sessionStorage.setItem('kp_offer', '1'); } catch (e) {}
    closeCart(); openModal(offer);
    const end = Date.now() + 300000, el = $('[data-offer-timer]', offer);
    clearInterval(offerT);
    offerT = setInterval(() => { const l = Math.max(0, Math.ceil((end - Date.now()) / 1000)); if (el) el.textContent = Math.floor(l / 60) + ':' + String(l % 60).padStart(2, '0'); if (!l) { clearInterval(offerT); location.href = checkoutUrl(); } }, 1000);
    return;
  }
  location.href = checkoutUrl();
}
if (offer) {
  const yes = $('[data-offer-yes]', offer), no = $('[data-offer-no]', offer);
  yes && yes.addEventListener('click', async () => {
    yes.classList.add('is-loading');
    try { await api('cart/add.js', { items: [{ id: +offer.dataset.variant, quantity: 1 }] }); } catch (e) {}
    const r = yes.getBoundingClientRect(); burst(r.left + r.width / 2, r.top, 60);
    setTimeout(() => { location.href = checkoutUrl(offer.dataset.code || null); }, 500);
  });
  no && no.addEventListener('click', () => { location.href = checkoutUrl(); });
}

/* ---------- spin wheel ---------- */
const wheel = $('#kp-wheel');
function queueWheel() {
  if (!wheel || store.get('kp_wheel', false) || $('#kp-age:not(.is-out)')) return;
  setTimeout(() => { if (!$('.kp-modal.is-open') && !(drawer && drawer.classList.contains('is-open'))) openModal(wheel); }, (+wheel.dataset.delay || 8) * 1000);
}
if (wheel) {
  const disc = $('[data-disc]', wheel), segs = $$('[data-prize]', wheel);
  let won = null, spinning = false;
  const spinBtn = $('[data-spin]', wheel);
  spinBtn && spinBtn.addEventListener('click', () => {
    if (spinning || won !== null || !segs.length) return;
    spinning = true; spinBtn.disabled = true;
    const w = segs.map(s => +s.dataset.weight || 1), tot = w.reduce((a, b) => a + b, 0);
    let r = Math.random() * tot, idx = 0;
    while (idx < w.length - 1 && r > w[idx]) { r -= w[idx]; idx++; }
    const seg = 360 / segs.length;
    disc.style.transform = 'rotate(' + (360 * 6 + (360 - (idx * seg + seg / 2))) + 'deg)';
    setTimeout(() => {
      won = idx; spinning = false;
      const lab = $('[data-won-label]', wheel); if (lab) lab.textContent = segs[idx].dataset.label;
      wheel.classList.add('has-won');
      const b = disc.getBoundingClientRect(); burst(b.left + b.width / 2, b.top + b.height / 2, 80);
    }, calm ? 300 : 5200);
  });
  const claim = $('[data-claim]', wheel);
  claim && claim.addEventListener('click', () => {
    const s = segs[won]; if (!s) return;
    store.set('kp_wheel', true);
    if (s.dataset.code) {
      store.set('kp_code', s.dataset.code);
      fetch(R + 'discount/' + encodeURIComponent(s.dataset.code), { credentials: 'same-origin' }).catch(() => {});
      toast(T('code_active', { code: s.dataset.code }));
    }
    closeModal(wheel); refresh();
  });
  $$('[data-close-modal]', wheel).forEach(b => b.addEventListener('click', () => store.set('kp_wheel', true)));
}

/* ---------- wishlist ---------- */
const wishEl = $('#kp-wish');
let WISH = store.get('kp_wish', []);
function wishRender() {
  $$('[data-wish-count]').forEach(e => { e.textContent = WISH.length; });
  $$('[data-wish]').forEach(b => b.classList.toggle('is-on', WISH.some(w => w.handle === b.dataset.handle)));
  if (wishEl) {
    const list = $('[data-wish-list]', wishEl);
    if (list) list.innerHTML = WISH.length ? WISH.map(w => '<a class="kp-wishitem" href="' + esc(w.url) + '"><img src="' + esc(w.img) + '" alt="" loading="lazy"><span>' + esc(w.title) + '</span><b>' + esc(w.price) + '</b></a>').join('') : '<p class="kp-muted">' + esc(T('wishlist_empty')) + '</p>';
  }
}
document.addEventListener('click', e => {
  const b = e.target.closest('[data-wish]');
  if (b) {
    e.preventDefault(); e.stopPropagation();
    const h = b.dataset.handle, i = WISH.findIndex(w => w.handle === h);
    if (i > -1) WISH.splice(i, 1);
    else { WISH.unshift({ handle: h, title: b.dataset.title, url: b.dataset.url, img: b.dataset.img, price: b.dataset.price }); const r = b.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 14); }
    store.set('kp_wish', WISH.slice(0, 60)); wishRender();
    return;
  }
  if (e.target.closest('[data-open-wish]')) { e.preventDefault(); wishRender(); openModal(wishEl); }
});

/* ---------- quiz ---------- */
$$('[data-quiz]').forEach(q => {
  let data; try { data = JSON.parse($('script[type="application/json"]', q).textContent); } catch (e) { return; }
  const modal = $('.kp-modal', q), body = $('[data-quiz-body]', q), dots = $$('.kp-quiz__dots i', q);
  const steps = (data.steps || []).filter(s => s.opts && s.opts.length);
  let ans = [];
  const draw = () => {
    dots.forEach((d, i) => d.classList.toggle('is-on', i <= ans.length));
    if (ans.length < steps.length) {
      const s = steps[ans.length];
      body.innerHTML = '<h2 class="kp-h3">' + esc(s.q) + '</h2><div class="kp-quiz__opts">' + s.opts.map((o, i) => '<button type="button" class="kp-quiz__opt" style="animation-delay:' + i * 60 + 'ms" data-qi="' + i + '"><b>' + esc(o.label) + '</b><small>' + esc(o.sub || '') + '</small></button>').join('') + '</div>';
      return;
    }
    result();
  };
  const result = async () => {
    body.innerHTML = '<h2 class="kp-h3">' + esc(data.result) + '</h2><div class="kp-qres"></div>';
    const picked = ans.map((a, i) => steps[i].opts[a]);
    const col = (picked.slice().reverse().find(o => o.collection) || {}).collection || data.fallback || 'all';
    const rng = picked.find(o => o.min !== null && o.min !== undefined && o.min !== '' || o.max) || {};
    const lo = parseFloat(rng.min) || 0, hi = parseFloat(rng.max) || 1e9;
    let prods = [];
    try { const j = await (await fetch(R + 'collections/' + encodeURIComponent(col) + '/products.json?limit=40')).json(); prods = (j.products || []).filter(p => p.variants.some(v => v.available)); } catch (e) {}
    let fit = prods.filter(p => { const pr = parseFloat(p.variants[0].price); return pr >= lo && pr <= hi; });
    if (fit.length < 4) fit = fit.concat(prods.filter(p => fit.indexOf(p) < 0));
    fit = fit.slice(0, 4);
    const box = $('.kp-qres', body);
    box.innerHTML = fit.map((p, i) => {
      const v = p.variants.find(x => x.available) || p.variants[0];
      const img = p.images && p.images[0] ? sized(p.images[0].src, 400) : '';
      return '<div class="kp-qres__i" style="animation-delay:' + i * 90 + 'ms"><a class="kp-qres__img" href="' + R + 'products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</a><span>' + esc(p.title) + '</span><div class="kp-qres__row"><b class="kp-price" style="font-size:16px">' + nfShop.format(parseFloat(v.price)) + '</b><button type="button" class="kp-mini" data-add-variant="' + v.id + '">+</button></div></div>';
    }).join('');
    if (fit.length) {
      const all = document.createElement('button');
      all.type = 'button'; all.className = 'kp-btn kp-btn--light'; all.textContent = T('add_all');
      all.addEventListener('click', () => { addItems(fit.map(p => ({ id: (p.variants.find(x => x.available) || p.variants[0]).id, quantity: 1 })), all); closeModal(modal); });
      body.appendChild(all);
      burst(innerWidth / 2, innerHeight / 2, 50);
    }
  };
  q.addEventListener('click', e => {
    if (e.target.closest('[data-quiz-open]')) { ans = []; draw(); openModal(modal); }
    const o = e.target.closest('[data-qi]');
    if (o) { ans.push(+o.dataset.qi); draw(); }
  });
});

/* ---------- product page ---------- */
const pdp = $('[data-pdp]');
if (pdp) {
  let P = null;
  try { P = JSON.parse($('[data-product-json]', pdp).textContent); } catch (e) {}
  const vid = $('[data-vid]', pdp), mainImg = $('#kp-main-img');
  let cur = P ? (P.variants.find(v => String(v.id) === String(vid && vid.value)) || P.variants[0]) : null;
  const sel = cur ? cur.options.slice() : [];
  const qtyInp = () => $('[data-qty]', pdp);
  function updateTiers() { const q = qtyInp() ? +qtyInp().value || 1 : 1; $$('[data-set-qty]', pdp).forEach(b => b.classList.toggle('is-on', +b.dataset.setQty === Math.min(3, q))); }
  function setVariant(v) {
    cur = v;
    if (vid) vid.value = v ? v.id : '';
    const pr = $('[data-price]', pdp), cp = $('[data-compare]', pdp), sv = $('[data-save]', pdp);
    if (v) {
      if (pr) pr.textContent = fmt(v.price);
      $$('[data-sticky-price]').forEach(x => { x.textContent = fmt(v.price); });
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      if (cp) { cp.hidden = !sale; if (sale) cp.textContent = fmt(v.compare_at_price); }
      if (sv) { sv.hidden = !sale; if (sale) sv.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
      if (v.featured_image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = sized(v.featured_image.src, 1200); }
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
    }
    $$('[data-atc]').forEach(b => { b.disabled = !v || !v.available; });
    $$('[data-atc-label]').forEach(l => { l.textContent = v && v.available ? T('add') : T('sold_out'); });
    $$('[data-opt-label]', pdp).forEach(l => { l.textContent = sel[+l.dataset.optLabel] || ''; });
    $$('[data-opt]', pdp).forEach(b => b.classList.toggle('is-on', sel[+b.dataset.opt] === b.dataset.val));
    updateTiers();
    fbtUpdate && fbtUpdate();
  }
  pdp.addEventListener('click', e => {
    const o = e.target.closest('[data-opt]');
    if (o && P) { sel[+o.dataset.opt] = o.dataset.val; setVariant(P.variants.find(v => v.options.every((x, i) => x === sel[i])) || null); return; }
    const th = e.target.closest('[data-thumb]');
    if (th && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = th.dataset.thumb; $$('[data-thumb]', pdp).forEach(t => t.classList.toggle('is-on', t === th)); return; }
    const qs = e.target.closest('[data-qstep]');
    if (qs && qtyInp()) { qtyInp().value = Math.max(1, (+qtyInp().value || 1) + +qs.dataset.qstep); updateTiers(); return; }
    const st = e.target.closest('[data-set-qty]');
    if (st && qtyInp()) { qtyInp().value = st.dataset.setQty; updateTiers(); }
  });
  qtyInp() && qtyInp().addEventListener('input', updateTiers);
  updateTiers();
  const z = $('[data-zoom]', pdp);
  if (z && mainImg && fine) {
    z.addEventListener('mousemove', e => { const r = z.getBoundingClientRect(); mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; mainImg.style.transform = 'scale(1.8)'; });
    z.addEventListener('mouseleave', () => { mainImg.style.transform = ''; });
  }
  const sticky = $('[data-sticky]'), atcBtn = $('[data-atc]', pdp);
  if (sticky && atcBtn && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(atcBtn);
  const co = $('[data-cutoff]', pdp);
  if (co) {
    const tpl = co.dataset.tpl || '';
    const tick = () => { const n = new Date(), c = new Date(n); c.setHours(KP.cutoff || 23, 0, 0, 0); let ms = c - n; if (ms < 0) ms += 864e5; const h = Math.floor(ms / 36e5), m = Math.floor(ms / 6e4) % 60; co.textContent = tpl.split('[time]').join(h + 'h ' + String(m).padStart(2, '0') + 'm'); };
    tick(); setInterval(tick, 30000);
  }
  if (pdp.dataset.handle) {
    const rv = store.get('kp_recent', []).filter(x => x.handle !== pdp.dataset.handle);
    rv.unshift({ handle: pdp.dataset.handle, title: pdp.dataset.title, url: pdp.dataset.url, img: pdp.dataset.img, price: pdp.dataset.price });
    store.set('kp_recent', rv.slice(0, 12));
  }
  var fbtUpdate = null;
  const fb = $('[data-fbt]', pdp);
  if (fb && P) (async () => {
    try {
      let j = await api('recommendations/products.json?product_id=' + P.id + '&limit=4&intent=complementary').catch(() => ({ products: [] }));
      let list = j.products || [];
      if (list.length < 2) { const j2 = await api('recommendations/products.json?product_id=' + P.id + '&limit=6').catch(() => ({ products: [] })); list = list.concat(j2.products || []); }
      list = list.filter((p, i, a) => p.available && p.id !== P.id && a.findIndex(x => x.id === p.id) === i).slice(0, 2);
      if (!list.length) return;
      const rows = list.map(p => ({ p: p, v: p.variants.find(x => x.available) || p.variants[0] }));
      $('[data-fbt-list]', fb).innerHTML = '<div class="kp-fbt__row"><span class="kp-check is-on">\u2713</span><img src="' + esc(sized(P.featured_image, 160)) + '" alt=""><span>' + esc(P.title) + '</span><b data-fbt-main></b></div>' +
        rows.map((r, i) => '<label class="kp-fbt__row"><input type="checkbox" checked data-fbt-i="' + i + '"><span class="kp-check">\u2713</span><img src="' + esc(sized(r.p.featured_image, 160)) + '" alt="" loading="lazy"><span>' + esc(r.p.title) + '</span><b>' + fmt(r.v.price) + '</b></label>').join('');
      fbtUpdate = () => {
        const on = $$('[data-fbt-i]', fb).filter(x => x.checked).map(x => rows[+x.dataset.fbtI]);
        const m = $('[data-fbt-main]', fb); if (m && cur) m.textContent = fmt(cur.price);
        $('[data-fbt-total]', fb).textContent = fmt((cur ? cur.price : 0) + on.reduce((a, r) => a + r.v.price, 0));
        return on;
      };
      fb.addEventListener('change', fbtUpdate);
      fbtUpdate();
      fb.hidden = false;
      $('[data-fbt-add]', fb).addEventListener('click', e => {
        if (!cur || !cur.available) return;
        const on = fbtUpdate();
        addItems([{ id: cur.id, quantity: 1 }].concat(on.map(r => ({ id: r.v.id, quantity: 1 }))), e.currentTarget);
      });
    } catch (e) {}
  })();
}

/* ---------- recommendations + recently viewed ---------- */
$$('[data-recs]').forEach(async s => {
  if (!s.dataset.url) return;
  try {
    const html = await (await fetch(s.dataset.url)).text();
    const n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
    if (n && n.innerHTML.trim()) { s.innerHTML = n.innerHTML; initReveal(s); wishRender(); }
  } catch (e) {}
});
$$('[data-recent]').forEach(s => {
  const curH = pdp ? pdp.dataset.handle : null;
  const list = store.get('kp_recent', []).filter(x => x.handle !== curH).slice(0, 10);
  if (!list.length) return;
  $('[data-recent-list]', s).innerHTML = list.map(x => '<a class="kp-rv" href="' + esc(x.url) + '"><i>' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy">' : '') + '</i><span>' + esc(x.title) + '</span><b>' + esc(x.price) + '</b></a>').join('');
  s.hidden = false;
});

/* ---------- newsletter success ---------- */
$$('[data-news-ok]').forEach(el => { if (location.search.indexOf('customer_posted=true') > -1) { el.hidden = false; const f = el.parentElement.querySelector('form'); if (f) f.hidden = true; burst(innerWidth / 2, innerHeight / 2, 50); } });

/* ---------- theme editor ---------- */
document.addEventListener('shopify:section:load', e => { initReveal(e.target); wishRender(); CART && render(CART); });

/* ---------- public api for kp-plus.js ---------- */
window.KPX = { $, $$, R, T, esc, fmt, sized, store, fine, calm, api, toast, burst, fly, openModal, closeModal, openCart, closeCart, refresh, addItems, initReveal, getCart: () => CART };

/* ---------- init ---------- */
wishRender();
refresh();
if (!$('#kp-age')) queueWheel();
})();
